import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from '@mui/material';
import ReactPlayer from 'react-player';

export default function VideoModal({ open, onClose, isSaving, savingError }) {
  const videoUrl = 'https://vimeo.com/1101999568/3f175e6b10';

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Welcome to the P.E.O. Hub!</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <ReactPlayer
              className="react-player"
              width="100%"
              url={videoUrl}
              playsinline={true}
              controls={true}
              playing={true}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSaving}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
